module.exports = __webpack_public_path__ + "img/telephone.148f5ba8.png";